module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._v("直接跳转到后台页面")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7df6ebe2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/jobContent.vue
// module id = 342
// module chunks = 1